export enum SOURCE {
    WEB = 'web',
    MOBILE = 'mobile',
    EMBEDDED = 'embedded',
}
